export const savingsOpportunitiesGroupingOptions = {
  opportunity_name: "Opportunity Name",
  action_type: "Opportunity Type",
  description: "Description",
  cloud_provider: "Cloud Provider",
  service: "Resource Type",
  resource_type: "Type",
  recommended_type: "Recommended Type",
  resource_id: "Resource ID/Name",
  resource_arn: "Resource ARN",
  implementation_effort: "Implementation Effort",
  based_on_past: "Based On Past",
  region: "Region",
  "account.provider_account_id": "Account",
};
